import { RegionInfoFilter } from "../../models/region";
import { useGetList } from "react-admin";
import { Box, Typography } from "@mui/material";
import { Bar, BarChart, Legend, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'


type RegionYearBuilt = {
  id: number;
  yearBuilt: number;
  yearBuiltCount: number;
}


export const RegionYearBuiltChart = ({ filter }: { filter: RegionInfoFilter }) => {

  const { data: yearBuiltData, isLoading: isLoadingYearBuilt } = useGetList<RegionYearBuilt>('region/year_built', { filter });

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <Box >
          <Typography>{`${payload[0].payload.yearBuilt}: ${payload[0].payload.yearBuiltCount}`}</Typography>
        </Box>
      );
    }

    return null;
  };
  
  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart
        width={500}
        data={yearBuiltData}
      >
        {/* <CartesianGrid strokeDasharray="3 3" /> */}
        <XAxis dataKey="yearBuilt" />
        <YAxis mirror />
        <Tooltip content={<CustomTooltip payload={yearBuiltData} />} />
        <Bar name={'Year Built'} dataKey="yearBuiltCount" fill='#82ca9d' activeBar={<Rectangle fill="gold" stroke="purple" />} />
        <Legend align='right' verticalAlign='top' />
      </BarChart>
    </ResponsiveContainer>
  )
};

